import React,{ useContext } from 'react'
import Particles from 'react-particles-js';
import styled from 'styled-components'
import { ThemeContext } from 'styled-components';
import { MyLogo } from '../components/MyLogo';
import NasaLight from '../config/particlesjs-nasa-light.json'
import NasaDark from '../config/particlesjs-nasa-dark.json'
import { BlogImageList } from '../data/BlogImageList'
import { TabletSize } from '../responsive/TabletSize';

const Wrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 20px;
`
const Conatiner = styled.div`
  z-index: 1;
  position: absolute;
  top: 90px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 0px 20px;
  h2{
    padding-top: 20px;
    color: ${props => props.theme.text};
    ${TabletSize({ fontSize: "20px" })}
  }
`

const ImageBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  &::-webkit-scrollbar {
    display: none;
  }
`

const ImageCard = styled.div`
  margin: 15px 20px 0px 0px;
  height: 300px;
  min-width: 250px;
  background-image: url(${props => props.bg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`


export const BlogPage = () => {

  const theme = useContext(ThemeContext)
  const background = theme.isLight ? NasaLight : NasaDark

  return (
    <Wrapper>
        <MyLogo/>
        <Particles 
          params={background} 
          canvasClassName={`${theme.isLight ? "particlesLight" : "particlesDark"}`}
        />
        <Conatiner>
          <h2>Personal Blog</h2>
          <ImageBox>
            {BlogImageList.personal.map((item, index) => (
              <ImageCard key={index} bg={item}/>
            ))}
          </ImageBox>
          <h2>Trip with Friends Blog</h2>
          <ImageBox>
            {BlogImageList.srtrip.map((item, index) => (
              <ImageCard key={index} bg={item}/>
            ))}
          </ImageBox>
          <h2>HighSchool Blog</h2>
          <ImageBox>
            {BlogImageList.highschool.map((item, index) => (
              <ImageCard key={index} bg={item}/>
            ))}
          </ImageBox>
          <h2>BacII Blog</h2>
          <ImageBox>
            {BlogImageList.bac2.map((item, index) => (
              <ImageCard key={index} bg={item}/>
            ))}
          </ImageBox>
          <h2>Coding Blog</h2>
          <ImageBox>
            {BlogImageList.coding.map((item, index) => (
              <ImageCard key={index} bg={item}/>
            ))}
          </ImageBox>
        </Conatiner>
     </Wrapper>
  )
}
